import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { baseURL, requestUrl } from "../../../Utils/baseUrls";
import { APIResponse, AxioMethodType, GenerationFinance, GenerationFinanceArea, GSTPERCENTAGE, SAMAPIGenerationBody } from "../../../Utils/Const";
import { ProjectTy } from "../Auth/types";
import { Fin, moduleInverterTy } from "./types";
import { toast } from "react-toastify";
import { fetchModuleInverter, FetchStringCount } from "./Api";
import globalLayers from "../../../Utils/CustomerMaps/Maps/GlobaLMap";
import Collection from "@arcgis/core/core/Collection";
import Graphic from "@arcgis/core/Graphic";
import { Polygon, SpatialReference } from "@arcgis/core/geometry";
import * as projection from "@arcgis/core/geometry/projection";

export interface electricalConfigurationResultTy {
  inverterCount: number
  totalPanelsUsed: number
  leftoverPanels: number
  totalDcPowerKW: number
  totalAcPowerKW: number
  dcAcRatio: number
  stringingPlan: StringingPlan[]
}

export interface StringingPlan {
  modulesPerString: number
  numberOfStrings: number
  panelCount: number
}

// import { toast } from "react-toastify/dist/core/toast";

enum GenerationType {pvnxt = 0,Sam = 1,}
enum WeatherDataType {nsrdb = 0,openmeteo = 1}
// const generationType = GenerationType.Sam;
const generationType = GenerationType.pvnxt;
const weatherDataType = WeatherDataType.openmeteo;

export const calcTariffRate = createAsyncThunk<any, any, {}>(
  "tariffRate/post",
  async (body, { rejectWithValue }) => {
    const { sanctionload, providerid, consumercategoryid } = body;
    try {
      const { data }: AxiosResponse<APIResponse<any>> = await baseURL.get(
        `${requestUrl.tariffRate}/${sanctionload}/${providerid}/${consumercategoryid}`
      );
      if (data.code !== "200") {
        return 0;
      }
      return data.responseData;
    } catch (error: any) {
      return 0;
    }
  }
);

  export const getCostBracket = createAsyncThunk<any, number, {}>(
    "project/getCostBracket",
    async (plantcapacity, { rejectWithValue }) => {
      // debugger

      const res: AxiosResponse<APIResponse<number>> = await baseURL.get(`${requestUrl.costbracket}/plantcosting/${plantcapacity}` );
      
      if (res.status === 409) {
        return rejectWithValue("Duplicate Record..");
      }

      if (res.status === 404) {
        return rejectWithValue("No Record Found..");
      }

      if (res.data.code === "200") {
        // debugger
        // if (res.data.responseData) {
        //   // GST calculation 
        //   //  return  res.data.responseData + (res.data.responseData * GSTPERCENTAGE / 100)

        //  return  res.data.responseData + (res?.data?.responseData)
        // }
        return res.data.responseData ;
      }

      if (res.data.code !== "200") {
        return rejectWithValue(res.data.responseData);
      }

    }
  );
  // deprecated
export const fetchpVAPIMonthly = createAsyncThunk<any, dataType>(
    'quickplantanalysis/electricitygeneration',
    async (body, { rejectWithValue }) => {
      const { modulePerString, totalSanctionLoad, lat, lng, india,} = body;
      try {
        if(totalSanctionLoad!==0){
          let token = localStorage.getItem("token") || document.cookie;
          // const postResponse1 = await baseURL.post(`${requestUrl.pvnxtapigeneration}/${totalSanctionLoad}/${lat}/${lng}/${india}/openmeteo`, SAMAPIGenerationBody
          // );

          const postResponse1 = await axios.get(`${requestUrl.pvnxtapigeneration}/${totalSanctionLoad}/${lat}/${lng}/${india}`, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Authorization': `bearer ${token}`
          },
          // body: SAMAPIGenerationBody
          });

       
          
          if (postResponse1.status === 200) {
            const responseData = postResponse1.data.responseData;
            // debugger
            if (typeof responseData === 'string') {
              const parsedData = JSON.parse(responseData);
              return { generation: parsedData, stringPerModule: modulePerString };
            } else {
              return rejectWithValue(responseData);
            }
          } else {
            return rejectWithValue(postResponse1.data);
          }
  
        }
      } catch (error: any) {
  
        // toast.error(error.message);
        return rejectWithValue(error.message || 'API request failed');
      }
    }
  );
  // deprecated
  export const fetchpVAPIMonthlyCase2 = createAsyncThunk<any, dataType>('quickplantanalysis/electricitygeneration_2',async (body,{rejectWithValue}) => {
    // debugger
       const { totalSanctionLoad, lat, lng, india } = body
      try {
        // const formData2 = getSAMAPIObject({ inverter, module, noOfString: noOfString, modulePerString, load: totalSanctionLoad, loadVal });
      
        let token = localStorage.getItem("token") || document.cookie;
        // const postResponse2 = await baseURL.post(`${requestUrl.pvnxtapigeneration}/${totalSanctionLoad}/${lat}/${lng}/${india}/openmeteo`,SAMAPIGenerationBody);
        const postResponse2 = await axios.get(`${requestUrl.pvnxtapigeneration}/${totalSanctionLoad}/${lat}/${lng}/${india}`, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `bearer ${token}`
        },
        // body: SAMAPIGenerationBody
        });
        
        // const postResponse = await axios.post(requestUrl.samAPI, formData2);  
        if (postResponse2.status === 200) {
          if (typeof postResponse2.data.responseData === 'string' && typeof JSON.parse(postResponse2.data.responseData) === 'object') {
  
            return postResponse2.data.responseData
            // return postResponse2.data.responseData.data
          } else {
            return rejectWithValue(postResponse2.data.responseData)
          }
        }
        else {
          return rejectWithValue(postResponse2.data)
        }
      } catch (error) {
        throw error;
      }
    }
  );
    // deprecated
  export const fetchFinanceby = createAsyncThunk<any, Fin>('finance/fetchFinance',async (body, thunkAPI) => {
        const {  electricityrate,monthlyGeneration,sanctionLoad } = body;
        let newbody = {electricityrate,monthlyGeneration,sanctionLoad};
        const postResponse = await baseURL.post(requestUrl.financial, newbody);
        if (postResponse.status === 200) {
            if (postResponse.data.code === '200') {
                await baseURL.get(`${requestUrl.project}/${body.projectid}/${postResponse.data.responseData.totalCarbonfootprint.toString()}/${postResponse.data.responseData.totalTrees.toString()}`)
                return postResponse.data.responseData
            } else {
                return thunkAPI.rejectWithValue(postResponse.data)
            }
        } else {
            return thunkAPI.rejectWithValue(postResponse.data)
        }
    }
);

// New generation (11/11/25) with financial on plant capacity
export const generationdegradationwithfinance  = createAsyncThunk("costbracket/genaration-degradation-finance",async (body: any, { rejectWithValue }) => {
    const { modulePerString, totalSanctionLoad, lat, lng, india,electricityrate ,totalarea, noOfModules, noOfString,module,inverter} = body;
    // Fetching module and inverter with load capacity 
    // console.log(totalSanctionLoad)
    if (!totalSanctionLoad || totalSanctionLoad === 0) return;

    // const data = await fetchModuleInverter(totalSanctionLoad);
    // if (!data) {rejectWithValue("Failed to fetch module and inverter details."); return};
    // const graphic  = globalLayers.sketchLayers?.graphics.filter(e => (e.attributes.name as string).includes('build')) as Collection<Graphic>
    //   let GenerationBody = GenerationFinanceArea(data,totalarea);
    //   const StringCount = await FetchStringCount({module_Voc: data?.module?.v_oc_ref,module_Vmpp: data?.module?.v_mp_ref,tempCoeffVocPercent: -0.126711,maxSystemVoltage: data?.inverter?.vdcmax,mppt_low: data?.inverter?.mppt_low,
    //     mppt_high: data?.inverter?.mppt_high,});
    //     if (!StringCount) {rejectWithValue("Failed to fetch string count."); return}

    // let token = localStorage.getItem("token") || document.cookie;
    // let newBoby = {...body};
    //   if(body.electicityRate && typeof body.electicityRate === 'string'){
    //     newBoby.electicityRate = parseFloat(body.electicityRate)
    //   }

    try {
      // const res = await baseURL.post(`${requestUrl.getgenerationwithfinance}/${totalSanctionLoad}/${lat}/${lng}?electricityRate=${electricityrate}&WdataSourceType=${weatherDataType}&GenerationType=${generationType}`, GenerationBody)
      // https://testapi.pvnxt.com/api/generationApi/GenerationMasterV1/28/77?load=5&electricityRate=10&isPanelLayerRequired=false
      const res = await baseURL.post(`${requestUrl.getgenerationwithfinanceV1}/${lat}/${lng}?load=${totalSanctionLoad}&electricityRate=${electricityrate}&isPanelLayerRequired=false&bestOnly=true&loadType=1&GenerationType=${generationType}`, {})
      if (res.status === 200) {
      
        const data = {
          generation: JSON.parse(res?.data?.responseData?.generation?.data) ?? 0,
        }
        // console.log("Res data  ===>>   ", data)
        return data
      }

    } catch (error) {
      console.log("Res error ==>> ",error)
    }
  }

)

// New generation with financial sanctionload

export const generationdegradationwithfinance2 = createAsyncThunk(
  "costbracket/genaration-degradation-finance2",
  async (body: any, { rejectWithValue }) => {

    // const { modulePerString, totalSanctionLoad, lat, lng, india,electricityrate, noOfString,module,inverter} = body;
    const { totalSanctionLoad, lat, lng, india,electricityrate,totalarea,module} = body;
   
    
    let token = localStorage.getItem("token") || document.cookie;
    let newBoby = {...body};
      if(body.electicityRate && typeof body.electicityRate === 'string'){
        newBoby.electicityRate = parseFloat(body.electicityRate)
      }

      const polygon = globalLayers.sketchLayers?.graphics.filter(e => e.geometry.type === 'polygon' && e.attributes.name)
      let poly =  null as Polygon | null
      if(polygon?.length){
        poly = (polygon.getItemAt(0).geometry as Polygon)
        if(poly.spatialReference.wkid === 102100){
          await projection.load();
          poly = projection.project(poly, new  SpatialReference({ wkid: 4326 })) as Polygon
        }
      }

      let loadtype = 1;
      let reqBody = { ring: { geometry:poly, mmsData: {}  } };
      if(!poly) {
        loadtype = 3
        reqBody = {} as any 
      }

    try {
      // const res = await baseURL.post(`${requestUrl.getgenerationwithfinanceV1}/${lat}/${lng}?load=${totalSanctionLoad}&electricityRate=${electricityrate}&isPanelLayerRequired=false&loadType=1&GenerationType=${generationType}`, GenerationBody)
      const res = await baseURL.post(`${requestUrl.getgenerationwithfinanceV1}/${lat}/${lng}?load=${totalSanctionLoad}&electricityRate=${electricityrate}&isPanelLayerRequired=false&bestOnly=true&loadType=${loadtype}&GenerationType=${0}`,reqBody )
      // const res = await baseURL.post(`${requestUrl.getgenerationwithfinance}/${totalSanctionLoad}/${lat}/${lng}?electricityRate=${electricityrate}&WdataSourceType=${weatherDataType}&GenerationType=${generationType}`, GenerationBody)
      if (res.status === 200) {
        const result = res?.data?.responseData;

        const {annualGeneration, financialSaving,investmentAnalysis, generationResult,electricalConfigurationResult} = result?.layoutGenerationFinance?.best ?? {};
        const typeLayout = electricalConfigurationResult as electricalConfigurationResultTy;
       
         const data = {
          loadData: {plant_ac_capacity:typeLayout?.totalAcPowerKW,plant_dc_capacity:typeLayout?.totalDcPowerKW},
          annualGeneration:annualGeneration,
          degrdation: investmentAnalysis, 
          financialSaving: financialSaving,
          generation: JSON.parse(generationResult?.value?.data ?? "{}"),
          environmentalImpact: { carbonFootPrint: financialSaving?.totalCarbonfootprint ?? "",  treesPlanted: financialSaving?.totalTrees ?? "", },
         };
  
        return data
      }

    } catch (error) {
      console.log("Res error ==>> ",error)
    }
  }
)
  
export const generationdegradation = createAsyncThunk(
  "costbracket/genaration-degradation",
  async (body: any, { rejectWithValue }) => {
    let newBoby = {...body};
    try {
      if(body.electicityRate && typeof body.electicityRate === 'string'){
        newBoby.electicityRate = parseFloat(body.electicityRate)
      }
    } catch (error) {
    }
      const res = await baseURL.post(`${requestUrl.generationdegradation}`, newBoby)
      if (res.status !== 200) {
          return rejectWithValue(res.data);
      }
      if (res.status === 200) {
          if (res.data.code === "200") {
              return res.data.responseData
          }
      } else {
          return rejectWithValue(res.data.responseData.message)
      }
  }
)

const headers = {
  'Content-Type': 'multipart/form-data'
}

type vals = { attribute: string, name: string, value: string }


export type commomRes = {
  efficiency: vals[]
  electrical: vals[]
  general: vals[]
  mechanicalCharacteristics: vals[],
  name: string,
  path: string,
  lat: number,
  lng: number,
}


type dataType = {
  data: { inverter: commomRes, module: commomRes },
  noOfString: number,
  totalSanctionLoad: number, 
  modulePerString?: number, 
  loadVal: boolean,
  lat: number,
  lng: number, 
  india: boolean
}
  export const fetchPANOND = async () => {
    
    const inverterResponse = await axios({url: '/inverter.OND',responseType: 'blob'})
    const moduleResponse = await axios({url: '/module.pan',responseType: 'blob'})
  
    const formDataInverter = new FormData();
    formDataInverter.append('file', inverterResponse.data)
  
    const formDataModule = new FormData();
    formDataModule.append('file', moduleResponse.data)
  
    const postResponseInverter = await baseURL.post(requestUrl.uploadInverter, formDataInverter, {
      headers: headers
    });
    
    const postResponseModule = await baseURL.post(requestUrl.uploadeModule, formDataModule, {
      headers: headers
    });
  
    return { inverter: postResponseInverter.data.responseData, module: postResponseModule.data.responseData }
  
  }
